import { styled } from 'styled-components';

export const InputWrapper = styled.div<{ $width?: number | string }>`
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colorBlackMainBorder};
  border-radius: 4px;
  width: ${({ $width }) => ($width ? `${$width}px` : 'auto')};
  overflow: hidden;
`;

export const Button = styled.button<{
  $disabled: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 8px;

  ${props =>
    props.$disabled &&
    `
    cursor: not-allowed;
    opacity: 0.5;
    `}
`;

export const InputField = styled.input`
  width: 40px;
  text-align: center;
  border: none;
  background: none;
  font-size: 16px;
  padding: 0;
  &:focus {
    outline: none;
  }
  &:disabled {
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
  }
`;
